import request from '@/utils/request'

export function pageVisitRecord(data) {
    const params = {
        header: {},
        content: data
    }
    return request({
        url: '/fjtec-sai-svc/config/pageVisitRecord',
        method: 'post',
        data: params
    })
}

export function countAll(data) {
    const params = {
        header: {},
        content: data
    }
    return request({
        url: '/fjtec-sai-svc/config/countAll',
        method: 'post',
        data: params
    })
}